import axios from 'axios';
import { takeLatest, put, select, call } from 'redux-saga/effects';
import { message } from 'antd';
import getMetricsData from '@api/metricContainer';
import { intervalSelector, filterSelector, selectedKPIConfigSelector } from '../base/selectors';
import * as actions from './actions';
import * as types from './types';
import * as helpers from './helper';
import * as adContentHelper from './adContentHelper';
import * as baseTypes from '../base/types';
import { activeTabSelector } from './selectors';
import { get } from 'lodash';
import { AdContentTabKey } from './reducer';

function* fetchData({ tabKey, createQuery}) {
  try {
    const interval = yield select(intervalSelector);
    const filter = yield select(filterSelector);
    const kpiConfig = yield select(selectedKPIConfigSelector);

    const payload = yield createQuery({
      interval: `${interval.from}/${interval.to}`,
      filter: filter.rule,
      tabKey,
      kpiConfig
    });

    yield put(actions.setLoadingState(tabKey, true));
    const source = axios.CancelToken.source();
    const response = yield call(
      getMetricsData,
      { queries: [payload] },
      { cancelToken: source.token }
    );

    yield put(actions.setResponse({
      tabKey,
      response: get(response, 'data[0]', null),
      errorMsg: '',
    }));

  } catch (error) {
    const errorMsg = error.message || 'Unknown error!';
    message.error(errorMsg);
    yield put(actions.setResponse({tabKey, response: null, errorMsg}));
  }
}

function* fetchTabs() {
  const tabKey = yield select(activeTabSelector);
  yield fetchData({ tabKey, createQuery: helpers.createQuery });
}

function* fetchAdContent() {
  yield fetchData({ tabKey: AdContentTabKey, createQuery: adContentHelper.createQuery });
}

function* initRequest() {
  yield put(actions.init());
}

function* watchInitRequest() {
  yield takeLatest([
    types.INIT,
  ], initRequest);
}

function* watchFetching() {
  yield takeLatest([
    types.FETCH_DATA,
    baseTypes.SET_INTERVAL,
    baseTypes.APPLY_FILTER,
    types.SET_ACTIVE_TAB,
    baseTypes.SET_SELECTED_KPI_CONFIG
  ], fetchTabs);
}

function* watchFetchingAdContent() {
  yield takeLatest([
    types.FETCH_DATA,
    baseTypes.SET_INTERVAL,
    baseTypes.APPLY_FILTER,
    baseTypes.SET_SELECTED_KPI_CONFIG
  ], fetchAdContent);
}

export default [
  watchInitRequest,
  watchFetching,
  watchFetchingAdContent,
];
